import { ReactNode } from "react";

// Plain-text empty / loading state, no border. See DESIGN.md "Empty / loading state".
export const ListEmpty = ({ children }: { children?: ReactNode }) => (
  <div className="py-2 text-sm text-muted-foreground">{children}</div>
);

export const ListLoading = ({ children }: { children?: ReactNode }) => (
  <div className="py-2 text-sm text-muted-foreground">{children ?? "Loading…"}</div>
);
